import { TrackingEvent, sendTrackingEvent } from '../services/service.tracking';
import { state as dynamicEntryState } from '../store/store.dynamic-entry';
import { SD_EVENTS } from '../utils/utils.shift-digital-analytics';

import { sendShiftDigitalAnalyticsEvent } from './tracking.interactiveBanner';

export const DynamicEntryEvents = {
  LOAD_ICO_HOME: 'ico_home',
  START_MY_OFFER: 'cta::start-my-offer',
  WHERE_IS_MY_VIN: 'text-link::whereismyvin',
  MILEAGE_CONTINUE: 'cta::mileage::next',
  STYLE_MILEAGE_CONTINUE: 'cta::style::next',
  PROCEED_WITHOUT_ICO: 'cta::proceed-without-instant-cash-offer',
  GO_YMM_MANUAL: 'cta::go::ymm_manual',
  START_MY_OFFER_SCAN: 'cta::start-my-offer-scan',
  START_SCAN: 'cta::scan',
};

export const trackDynamicEntry = (eventResult: string) => {
  let eventData = undefined;
  const event: TrackingEvent = {
    event: 'analytics_event',
    eventAction: 'click',
    eventResult,
    eventNonInteractive: false,
  };

  if (eventResult === DynamicEntryEvents.WHERE_IS_MY_VIN) {
    eventData = {
      vehicle: {
        entry: 'vin',
      },
    };
  }

  if ([DynamicEntryEvents.MILEAGE_CONTINUE, DynamicEntryEvents.STYLE_MILEAGE_CONTINUE].includes(eventResult)) {
    const { mileage, trimId } = dynamicEntryState;
    eventData = {
      vehicle: { mileage, trimId },
    };
  }

  if (eventData) {
    event.eventData = eventData;
  }
  sendTrackingEvent({ ...event });
};

export const trackStartMyOfferError = (errMessage) => {
  if (errMessage === 'vin_active_dealer_listing_error') {
    trackDynamicEntry(`cta::go-ineligible::listedvin`);
  } else {
    trackDynamicEntry(`cta::start-my-offer-error::${errMessage}`);
  }
};

const AUTOCHECK_MAP = {
  salvage: 'salvage',
  frameDamage: 'frame',
  previouslyCanadian: 'canadianreg',
  notActualMileage: 'mileage',
  floodDamage: 'flood',
  policeUse: 'policeuse',
  auctionAnnouncementWithin45Days: 'auctionapi',
  governmentUse: 'governmentuse',
  liveryUse: 'liveryuse',
  taxiUse: 'taxiuse',
  vm: 'vm',
  year: 'year',
};

export const trackStartMyOfferIneligible = (autocheckData) => {
  const ineligibleResponse = [];
  for (const key in AUTOCHECK_MAP) {
    if (autocheckData[key] === true) {
      ineligibleResponse.push(AUTOCHECK_MAP[key]);
    }
  }

  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult: `cta::start-my-offer-ineligible::${ineligibleResponse.join('|')}`,
    eventNonInteractive: false,
  });
};

export const trackStartMyOfferSuccess = (eventResult) => {
  sendTrackingEvent({
    event: 'analytics_event',
    eventAction: 'click',
    eventResult,
    eventNonInteractive: false,
  });
};

export const dynamicEntryShiftDigitalTradeInVehicleIndicated = () => {
  sendShiftDigitalAnalyticsEvent({
    events: SD_EVENTS.tradeInVehicleIndicated,
    tradeInYear: dynamicEntryState.yearId.toString(),
    tradeInMake: dynamicEntryState.make,
    tradeInModel: dynamicEntryState.model,
  });
};

export const shiftDigitalTradeInStart = () => {
  sendShiftDigitalAnalyticsEvent({
    events: SD_EVENTS.tradeInStart,
  });
};
